export const bootstrap = () => dispatch => {
  dispatch({
    type: 'application/BOOTSTRAP'
  });
};

export const loading = param => dispatch => {
  dispatch({
    type: 'application/LOADING',
    param
  });
};
